import i18next from 'i18next';

import R1 from 'resources/land_categories/r1.svg';
import R2 from 'resources/land_categories/r2.svg';
import R3 from 'resources/land_categories/r3.svg';
import R4 from 'resources/land_categories/r4.svg';

export const getCompaniesOptions = (companies) => {
    let items = companies.map((item) => {
        return {
            label: item.name,
            value: item.id,
        };
    });

    return [
        {
            label: i18next.t('All text', { context: 'female', count: 2 }),
            value: 'all',
        },
        ...items,
    ];
};

export const getLandCategories = () => {
    return [
        {
            image: R1,
            label: `R1 ${i18next.t('Open ground')}`,
            value: 1,
        },
        {
            image: R2,
            label: `R2 ${i18next.t('Undulating terrain')}`,
            value: 2,
        },
        {
            image: R3,
            label: `R3 ${i18next.t('Terrain with medium obstructions')}`,
            value: 3,
        },
        {
            image: R4,
            label: `R4 ${i18next.t('Terrain with high obstructions')}`,
            value: 4,
        },
    ];
};
